   <!-- header area start -->
   <div class="header2">
    <div class="">
        <div class="topHeader">
            <div class="logo">
              
                <img src="../../../../assets/img/autotrader.png" alt="">

                <i class="fa-solid fa-bars"></i>
            </div>
          <div class="search">
                <input type="text" class="form-control">
                <button class="btn" type="button"><i class="fa-solid fa-magnifying-glass"></i> Search</button>
            </div>

            <div class="login">
                <ul class="log">
                    <li>
                        <div class="dropdown">
                            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                              English
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                              <li><a class="dropdown-item" href="#">Arabic</a></li>
                              <li><a class="dropdown-item" href="#">French</a></li>
                              <li><a class="dropdown-item" href="#">German</a></li>
                            </ul>
                          </div>
                    </li>

                    <li>
                        <a href="">
                            <img src=".//img/Vector.png" alt="">
                            Login
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bottomHeader">
            <ul>
                <li><a  [routerLink]="['/'+ handle]"><i class="fa-solid fa-house"></i> Home</a></li>
                <li><a href="">Used Cars</a></li>
                <li><a href="">Compare</a></li>
                <li><a href="">Deals</a></li>
            </ul>

            <a href="#">
                <button class="btn" type="button">Sell Your Car</button>
            </a>
            
        </div>
    </div>
</div> 
<!-- header area end -->

<section class="listDetail py-5">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
              <div class="listingDetail py-5">
                <div class="propertyId d-flex justify-content-between">
                    <p class="mb-0">Property ID: <span>RH-2017-06</span></p>
                  <ul class="m-0">
                    <li><a href="#"><svg height="24px" style="enable-background:new 0 0 80 90;" version="1.1" viewBox="0 0 80 90" width="18px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M65,60c-3.436,0-6.592,1.168-9.121,3.112L29.783,47.455C29.914,46.654,30,45.837,30,45c0-0.839-0.086-1.654-0.217-2.456   l26.096-15.657C58.408,28.833,61.564,30,65,30c8.283,0,15-6.717,15-15S73.283,0,65,0S50,6.717,50,15   c0,0.837,0.086,1.654,0.219,2.455L24.123,33.112C21.594,31.168,18.438,30,15,30C6.717,30,0,36.717,0,45s6.717,15,15,15   c3.438,0,6.594-1.167,9.123-3.113l26.096,15.657C50.086,73.346,50,74.161,50,75c0,8.283,6.717,15,15,15s15-6.717,15-15   S73.283,60,65,60z"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></a></li>
                    <li><a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 21">
                        <path class="rh_svg" d="M1089.48,1923.98a6.746,6.746,0,0,1,9.54,9.54L1089,1943l-10.02-9.48a6.746,6.746,0,0,1,9.54-9.54A0.641,0.641,0,0,0,1089.48,1923.98Z" transform="translate(-1077 -1922)"></path>
                      </svg></a></li>
                    <li><a href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M1144,1942l-8,1v3l-7-5,7-5v3l8,1A1,1,0,0,1,1144,1942Zm-22-14,8,1v3l7-5-7-5v3l-8,1A1,1,0,0,0,1122,1928Z" transform="translate(-1121 -1922)"></path>
                      </svg></a></li>
                    <li><a href="#"><svg height="24px" version="1.1" viewBox="0 0 16 16" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                            <g fill="#000000" transform="translate(-672.000000, -48.000000)"><path d="M672,54 C672,53 673,52 674,52 L675,52 L675,54 L675,55 L685,55 L685,54 L685,52 L686,52 C687,52 688,53 688,54 L688,59 C688,60 687,61 686,61 L685,61 L685,59 L685,58 L675,58 L675,59 L675,61 L674,61 C673,61 672,60 672,59 L672,54 L672,54 Z M676,61 L676,59 L684,59 L684,61 L684,64 L676,64 L676,61 L676,61 Z M684,52 L684,54 L676,54 L676,52 L676,49 L684,49 L684,52 L684,52 Z M677,60 L677,61 L683,61 L683,60 L677,60 L677,60 Z M677,62 L677,63 L683,63 L683,62 L677,62 L677,62 Z M677,62"></path>
                            </g>
                        </g>
                    </svg></a></li>
                  </ul>
                </div>
                <ul class="propertyList d-flex mb-3 ">
                    <li>
                        Bedrooms
                        <div class="metaIcon mt-1">
                          <i class="fa-solid fa-bed"></i>
                          <span>{{details?.Bathrooms}}</span>
                        </div>
                    </li>
                    <li>
                        Bathrooms
                        <div class="metaIcon mt-1">
                          <i class="fa-solid fa-shower"></i>
                          <span>{{details?.Bathrooms}}</span>
                        </div>
                    </li>
                    <li>
                        Garage 
                        <div class="metaIcon mt-1">
                          <i class="fa-solid fa-garage-open"></i>
                          <span>2</span>
                        </div>
                    </li>
                    <li>
                      Year Built
                        <div class="metaIcon mt-1">
                          <i class="fa-solid fa-building"></i>
                          <span>2014</span>
                        </div>
                    </li>
                    <li>
                      Area          
                      <div class="metaIcon mt-1">
                        <i class="fa-sharp fa-regular fa-square"></i>
                        <span>4300</span>
                        <span>Sq Ft</span>
                      </div>
                  </li>
                    <li>
                        Lot Size            
                        <div class="metaIcon mt-1">
                          <i class="fa-sharp fa-regular fa-square"></i>
                          <span>{{details?.PricePerSqFt}}</span>
                          <span>Sq Ft</span>
                        </div>
                    </li>
                </ul>
                <div class="propertyContent">
                  <h3 class="propertyHeading">Description </h3>
                  <p>{{details?.Description}}</p>
                </div>
                <div class="additionalDetails">
                  <h3 class="propertyHeading">Additional Details</h3>
                  <ul class="additionafix mb-4"> 
                    <li>
                    <span class="title">BEDROOM FEATURES:</span>
                    <span class="value">Main Floor Master Bedroom, Walk-In Closet</span>
                </li>
                      <li>
                    <span class="title">DINING AREA:</span>
                    <span class="value">Breakfast Counter/Bar, Living/Dining Combo</span>
                </li>
                      <li>
                    <span class="title">DOORS &amp; WINDOWS:</span>
                    <span class="value">Bay Window</span>
                </li>
                      <li>
                    <span class="title">ENTRY LOCATION:</span>
                    <span class="value">Mid Level</span>
                </li>
                      <li>
                    <span class="title">EXTERIOR CONSTRUCTION:</span>
                    <span class="value">Wood</span>
                </li>
                      <li>
                    <span class="title">FIREPLACE FUEL:</span>
                    <span class="value">Pellet Stove</span>
                </li>
                      <li>
                    <span class="title">FIREPLACE LOCATION:</span>
                    <span class="value">Living Room</span>
                </li>
                      <li>
                    <span class="title">FLOORS:</span>
                    <span class="value">Raised Foundation, Vinyl Tile, Wall-to-Wall Carpet, Wood</span>
                </li>
          </ul>
                </div>
                <div class="commonNote">
                  <h3 class="propertyHeading">Common Note</h3>
                  <p>This is a sample note to share some basic information on all properties. This note can be enabled or disabled from Real Homes settings and its text plus label is fully customizable.</p>
                </div>
                <div class="propertyFeatures">
                  <h3 class="propertyHeading">Features</h3>
                  <ul class="">
                   <li><i class="fa-solid fa-check"></i><a href="#">2 Stories</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Bike Path</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Central Cooling</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Central Heating</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Dual Sinks</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Electric Range</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Fire Place</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Home Theater</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Laundry Room</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Lawn</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Marble Floors</a></li>
                   <li><i class="fa-solid fa-check"></i><a href="#">Swimming Pool</a></li>


                  </ul>
                </div>
                <div class="listingAccordion py-4">
                  <h3 class="propertyHeading">Floor Plans</h3>
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <div class="floorplanTittle">
                        <h2 class="accordion-header" id="headingOne">
                          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Ground Floor
                            <div class="floorPlan">
                              <span>2500 sq ft  </span>
                              <span>1 Bedroom</span>
                              <span>1 Bathroom</span>
                            </div>
                          </button>
                        </h2>
                       
                      </div>
                      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                       <p>Progressively maintain extensive infomediaries via extensible niches. Dramatically disseminate standardized metrics after resource-leveling processes. Objectively pursue diverse catalysts for change for interoperable meta-services.

                       </p>
                       <a href="#"><img src="	https://modern.b-cdn.net/wp-content/uploads/2017/06/floor-plan-00.jpg" alt="" width="100%"></a>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          First Floor
                          <div class="floorPlan">
                            <span>1700 sq ft  </span>
                            <span>2 Bedroom</span>
                            <span>2 Bathroom</span>
                          </div>
                        </button>
                      </h2>
                      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                        <p>Dynamically target high-payoff intellectual capital for customized technologies. Objectively integrate emerging core competencies before process-centric communities. Dramatically evisculate holistic innovation rather than client-centric data.</p>
                          <a href="#"><img src="https://modern.b-cdn.net/wp-content/uploads/2017/06/floor-plan-01.jpg" alt="" width="100%"></a>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="propertyAttachments">
                  <h3 class="propertyHeading">Property Attachments</h3>
                  <ul class="d-flex">
                    <li><a href="#"><i class="far fa-file-word"></i> Demo Word Document</a></li>
                    <li><a href="#"><i class="far fa-file-pdf"></i>Demo PDF Document</a></li>
                  </ul>
                </div>
                <div class="energyPerformance">
                  <h3 class="propertyHeading">Energy Performance</h3>
                    <ul class="additionafix mb-3"> 
                        <li>
                            <span class="title">ENERGY CLASS:</span>
                            <span class="value">B</span>
                        </li>
                        <li>
                            <span class="title">ENERGY PERFORMANCE:</span>
                            <span class="value">82 kWh/m²a</span>
                        </li>
                        <li>
                            <span class="title">EPC CURRENT RATING:</span>
                            <span class="value">82</span>
                        </li>
                          <li>
                            <span class="title">EPC POTENTIAL RATING:</span>
                            <span class="value">86</span>
                        </li>
                  </ul>
                  <ul class="energyClass d-flex mb-4">
                    <li>A+</li>
                    <li>A</li>
                    <li>B</li>
                    <li>C</li>
                    <li>D</li>
                    <li>E</li>
                    <li>F</li>
                    <li>G</li>
                  </ul>
                </div>
                <div class="PropertyVideo mb-4">
                  <h3 class="propertyHeading">Property Video</h3>
                  <div class="ratio ratio-16x9">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/PkjpPQxknPg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                  </div>
                 </div>
                 <div class="virtualTour">
                  <h3 class="propertyHeading">Virtual Tour</h3>
                  <figure>
                    <img src="https://modern.b-cdn.net/wp-content/uploads/2020/06/exterior-00-680x510.jpg" alt="" width="100%">
                  </figure>
                 </div>
                 <div class="propertyMap">
                  <h3 class="propertyHeading">Property on Map</h3>
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224356.85923258337!2d77.23701138029932!3d28.52240403621733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sNoida%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1684497032965!5m2!1sen!2sin" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                 </div>
                <div class="mortgageCalculator">
                  <h3 class="propertyHeading">Mortgage Calculator</h3>
                  <div class="row">
                    <div class="col-md-6">
                      <form class="propertyForm">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label">Term</label>
                          <select class="form-select" id="floatingSelectGrid" aria-label="Floating label select example">
                            <option selected>30 Years Fixed</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </select>
                        </div>
                        <div class="mb-2">
                          <label for="exampleInputPassword1" class="form-label">Interest</label>
                          <input type="text" class="form-control" value="3.5">
                          <input class="intersetSlider" type="range" min="0" max="10" step="0.1" value="3.5">
                        </div>
                        <div class="mb-2">
                          <label for="exampleInputPassword1" class="form-label">Home Price</label>
                          <input type="text" class="form-control"  value="540000">
                          <input class="intersetSlider" type="range" min="0" max="10" step="0.1" value="3.5">
                        </div>
                        <div class="mb-2">
                          <label for="exampleInputPassword1" class="form-label">Down Payment</label>
                          <input type="text" class="form-control"  value="540000">
                          <input type="text" class="form-control"  value="10%">
                          <input class="intersetSlider" type="range" min="0" max="10" step="0.1" value="3.5">
                        </div>
                       
                      </form>
                    </div>
                    <div class="col-md-6">
                      
                    </div>
                  </div>
                </div>
               
               
            </div>
            <div class="similarProperties my-4">
              <h3 class="propertyHeading">Similar Properties</h3>
              <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="pills-Recommended-tab" data-bs-toggle="pill" data-bs-target="#pills-Recommended" type="button" role="tab" aria-controls="pills-Recommended" aria-selected="true">Recommended</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="pills-Property-tab" data-bs-toggle="pill" data-bs-target="#pills-Property" type="button" role="tab" aria-controls="pills-Property" aria-selected="false">Property Features</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="pills-Type-tab" data-bs-toggle="pill" data-bs-target="#pills-Type" type="button" role="tab" aria-controls="pills-Type" aria-selected="false">Property Type</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="pills-Location-tab" data-bs-toggle="pill" data-bs-target="#pills-Location" type="button" role="tab" aria-controls="pills-Location" aria-selected="false">Property Location</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="pills-Status-tab" data-bs-toggle="pill" data-bs-target="#pills-Status" type="button" role="tab" aria-controls="pills-Status" aria-selected="false">Property Status</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="pills-Agent-tab" data-bs-toggle="pill" data-bs-target="#pills-Agent" type="button" role="tab" aria-controls="pills-Agent" aria-selected="false">Property Agent</button>
                </li>
              </ul>
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-Recommended" role="tabpanel" aria-labelledby="pills-Recommended-tab">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="listingCard propertyCard">
                        <div class="imageWrapper">
                            <a href="#"><img src="https://modern.b-cdn.net/wp-content/uploads/2020/06/exterior-03-680x510.jpg" alt=""></a>
                            <div class="viewProperty">
                              <a href="#">View Property</a>
                            </div>
                        </div>
                        <div class="bottomDetails border-0">
                            <div class="paddingSection">
                                <a href="#">
                                    <h5>Single Home at Florida 5, Pinecrest</h5>
                                </a>
                                <div class="addedSty">
                                    <p>Enchanting three bedroom, three bath home with spacious one bedroom,…</p> 
                                </div>
      
                                <ul>
                                    <li>
                                        Bedrooms
                                        <div class="metaIcon mt-1">
                                          <i class="fa-solid fa-bed"></i>
                                          <span>3</span>
                                        </div>
                                    </li>
      
                                    <li>
                                        Bathrooms
                                        <div class="metaIcon mt-1">
                                          <i class="fa-solid fa-shower"></i>
                                          <span>3.5</span>
                                        </div>
                                    </li>
                                    <li>
                                        Area
                                        <div class="metaIcon mt-1">
                                          <i class="fa-sharp fa-regular fa-square"></i>
                                          <span>3500</span>
                                          <span>Sq Ft</span>
                                        </div>
                                    </li>
                                </ul>
                                <div class="price-fav-box">
                                  <div class="price-pabel">
                                      <span class="card-status"> For Sale    </span>
                                      <p class="card-price"> $540,000  </p>
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="listingCard propertyCard" >
                        <div class="imageWrapper featrue">	
                          <span class="labelFeatured">Featured</span>
                            <a href="#"><img src="https://modern.b-cdn.net/wp-content/uploads/2020/06/apartment-00-680x510.jpg" alt=""></a>
                            <div class="viewProperty">
                              <a href="#">View Property</a>
                            </div>
                        </div>
                        <div class="bottomDetails border-0">
                            <div class="paddingSection">
                                <a href="#">
                                    <h5>Building Having 15 Apartments</h5>
                                </a>
                                <div class="addedSty">
                                    <p>Maecenas faucibus mollis interdum. Aenean eu leo quam. Pellentesque ornare…</p> 
                                </div>
      
                                <ul>
                                    
                                    <li>
                                        Area
                                        <div class="metaIcon mt-1">
                                          <i class="fa-sharp fa-regular fa-square"></i>
                                          <span>3500</span>
                                          <span>Sq Ft</span>
                                        </div>
                                    </li>
                                </ul>
                                <div class="price-fav-box">
                                  <div class="price-pabel">
                                      <span class="card-status"> For Sale    </span>
                                      <p class="card-price">  $6,950,000 </p>
                                  </div>
                                </div>
                            </div>
                           
                        </div>
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="pills-Property" role="tabpanel" aria-labelledby="pills-Property-tab">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="listingCard propertyCard">
                        <div class="imageWrapper">
                            <a href="#"><img src="https://modern.realhomes.io/wp-content/uploads/2020/06/condos-00-680x510.jpg" alt=""></a>
                            <div class="viewProperty">
                              <a href="#">View Property</a>
                            </div>
                        </div>
                        <div class="bottomDetails border-0">
                            <div class="paddingSection">
                                <a href="#">
                                    <h5>Condo on Biscayne Boulevard</h5>
                                </a>
                                <div class="addedSty">
                                    <p>A decent 2 bedrooms condo available on rent on an…</p> 
                                </div>
      
                                <ul>
                                    <li>
                                        Bedrooms
                                        <div class="metaIcon mt-1">
                                          <i class="fa-solid fa-bed"></i>
                                          <span>2</span>
                                        </div>
                                    </li>
      
                                    <li>
                                        Bathrooms
                                        <div class="metaIcon mt-1">
                                          <i class="fa-solid fa-shower"></i>
                                          <span>2</span>
                                        </div>
                                    </li>
                                    <li>
                                        Area
                                        <div class="metaIcon mt-1">
                                          <i class="fa-sharp fa-regular fa-square"></i>
                                          <span>1500</span>
                                          <span>Sq Ft</span>
                                        </div>
                                    </li>
                                </ul>
                                <div class="price-fav-box">
                                  <div class="price-pabel">
                                      <span class="card-status"> For Rent </span>
                                      <p class="card-price"> $3,250 Monthly  </p>
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="listingCard propertyCard">
                        <div class="imageWrapper featrue">	
                          <span class="labelFeatured">Featured</span>
                            <a href="#"><img src="https://modern.b-cdn.net/wp-content/uploads/2020/06/apartment-00-680x510.jpg" alt=""></a>
                            <div class="viewProperty">
                              <a href="#">View Property</a>
                            </div>
                        </div>
                        <div class="bottomDetails border-0">
                            <div class="paddingSection">
                                <a href="#">
                                    <h5>Luxury Apartment</h5>
                                </a>
                                <div class="addedSty">
                                    <p>Luxury Apartment available in an ideal location, with city and…</p> 
                                </div>
      
                                <ul>
                                  <li>
                                    Bedrooms
                                    <div class="metaIcon mt-1">
                                      <i class="fa-solid fa-bed"></i>
                                      <span>2</span>
                                    </div>
                                </li>
  
                                <li>
                                    Bathrooms
                                    <div class="metaIcon mt-1">
                                      <i class="fa-solid fa-shower"></i>
                                      <span>2</span>
                                    </div>
                                </li>
                                <li>
                                    <li>
                                        Area
                                        <div class="metaIcon mt-1">
                                          <i class="fa-sharp fa-regular fa-square"></i>
                                          <span>1650</span>
                                          <span>Sq Ft</span>
                                        </div>
                                    </li>
                                    
                                </ul>
                                <div class="price-fav-box">
                                  <div class="price-pabel">
                                      <span class="card-status">For Rent   </span>
                                      <p class="card-price"> $2,500 Monthly </p>
                                  </div>
                                </div>
                            </div>
                           
                        </div>
                      
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="pills-Type" role="tabpanel" aria-labelledby="pills-Type-tab">3</div>
                <div class="tab-pane fade" id="pills-Location" role="tabpanel" aria-labelledby="pills-Location-tab">4</div>
                <div class="tab-pane fade" id="pills-Status" role="tabpanel" aria-labelledby="pills-Status-tab">5</div>
                <div class="tab-pane fade" id="pills-Agent" role="tabpanel" aria-labelledby="pills-Agent-tab">6</div>
              </div>
            </div>
            <div class="propertyComments p-4">
              <div class="comment d-flex justify-content-between ">
                <h3> <i class="fas fa-comments" aria-hidden="true"></i>1 Comment </h3>
                <ul>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li> Review 1 </li>
                
                </ul>
              </div>
              <div class="commentList d-flex mb-4">
                <a href="#"><img src="https://secure.gravatar.com/avatar/72437d09babba5f052666cc37c91f152?s=110&d=mm&r=g" alt=""></a>
                <div class="commentDetail ms-4">
                  <H4>
                    John Doe
                    on October 21, 2020 at 10:43 am said  </H4>
                  <P>This is a sample comment. We have been extremely pleased with your attentiveness, communication, honesty and advice throughout the entire process. Selling a house is a stressful occurrence for anyone and you have helped to make it as smooth as possible for us. We feel that you truly go beyond the general duties of a real estate agent with thorough follow ups, reporting and always being ‘on top’ of potential buyers.</P>
                  <div class="comment star">
                    <ul class="mb-3">
                      <li><a href=""><i class="fas fa-star rated"></i></a></li>
                      <li><a href=""><i class="fas fa-star rated"></i></a></li>
                      <li><a href=""><i class="fas fa-star rated"></i></a></li>
                      <li><a href=""><i class="fas fa-star rated"></i></a></li>
                      <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  </ul>
                  <a href="#">Reply</a>
                  </div>
                 
                </div>
              </div>
              <div class="comment star justify-content-between ">
                <h3>Leave a Reply</h3>
                <ul class="my-3">
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                  <li><a href=""><i class="fas fa-star rated"></i></a></li>
                </ul>
                <p>Your email address will not be published.
                  Required fields are marked *</p>
                  <form class="propertyForm">
                  <div class="row">
                   <div class="col-md-12">
                    <div class="mb-3">
                      <label for="exampleInputComment" class="form-label">Comment *</label>
                      <textarea class="form-control"></textarea>
                    
                    </div>
                   </div>
                   <div class="col-md-6">
                    <div class="mb-3">
                      <label for="exampleInputPassword1" class="form-label">Name *</label>
                      <input type="name" class="form-control" id="exampleInputname1">
                    </div>
                   </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="exampleInputPassword1" class="form-label">Email *</label>
                        <input type="email" class="form-control" id="exampleInputemail1">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="exampleInputPassword1" class="form-label">Website *</label>
                        <input type="website" class="form-control" id="exampleInputwebsite1">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button type="submit" class="btn btn-primary">Post Comment</button>
                    </div>
                    
                  </div>
                </form>
              </div>
            </div>
          </div>
            <div class="col-md-4">
              <div class="sidebarCard">
               <div class="sidebarPro">
                <a><img src="https://modern.b-cdn.net/wp-content/uploads/2015/07/agent-female-00-210x210.jpg" alt="" width="120px"></a>
               </div>
                <div class="sidebarInfo mb-3">
                  <h3><a>{{dealerData.DealerName}}</a></h3>
                  <ul>
                    <li>Office: <a href="#"> 1-222-333-4444</a></li>
                    <li>Mobile:<a href="#"> {{dealerData.MobileCountryCode}} {{dealerData.MobileNumber}}</a></li>
                    <li>Fax: <a href="#"> {{dealerData.FaxNumber}}</a></li>
                    <li>WhatsApp: <a href="#"> 1-234-456-7895</a></li>
                    <li>Email:<a href="#"> {{dealerData.EmailID}}</a></li>
                  </ul>
                </div>
                <a class="viewMy"  href="https://live.instaciti.com/{{dealerData.CityName}}/automative" style="cursor: pointer;">  View My Listings </a>
                <form class="pt-3 " >
                  <div class="mb-3 px-3">
                    <label for="exampleInputEmail1" class="form-label">Name</label>
                    <input type="name" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Name">
                  </div>
                  <div class="mb-3 px-3">
                    <label for="exampleInputPassword1" class="form-label">Email</label>
                    <input type="email" class="form-control" id="exampleInputPassword1" placeholder="Email">
                  </div>
                  <div class="mb-3 px-3">
                    <label for="exampleInputPassword1" class="form-label">phone</label>
                    <input type="phone" class="form-control" id="exampleInputPassword1" placeholder="phone">
                  </div>
                  <div class="mb-3 px-3">
                    <label for="exampleInputPassword1" class="form-label">phone</label>
                   <textarea class="form-control">Hello, I am interested in [Home in Merrick Way].  </textarea>
                  </div>
                  <div class="mb-3 px-3 form-check">
               
                    <input type="checkbox" class="form-check-input" id="exampleCheck1">
                    <label class="form-check-label" for="exampleCheck1">I consent to having this website store my submitted information so they can respond to my inquiry.</label>
                  </div>
                  <div class="btn-group" role="group" aria-label="Basic checkbox toggle button group">
                    <label class="btn btn-outline-primary" for="btncheck1"><i class="fa-brands fa-whatsapp"></i>WhatsApp </label>
                    <label class="btn btn-outline-primary" for="btncheck2"><i class="fa-solid fa-phone"></i>Call Now </label>
                
                  </div>
                  <div class="btn-group mt-3" role="group" aria-label="Basic checkbox toggle button group">
                     <label class="btn message btn-outline-primary" for="btncheck2"><i class="fa-light fa-message"></i>Send Message </label>
                  
                  </div>
                </form>
              </div>
              <div class="sidebarCard mb-4">
                <div class="sidebarPro">
                 <a href="#" ><img src="https://modern.b-cdn.net/wp-content/uploads/2015/07/agent-male-00-210x210.jpg" alt="" width="120px"></a>
                </div>
                 <div class="sidebarInfo mb-3">
                   <h3><a href="#">Agent John David <i class="fa-solid fa-check"></i></a></h3>
                   <ul>
                     <li>Office: <a href="#"> 1-222-333-4444</a></li>
                     <li>Mobile:<a href="#"> 1-234-456-7892</a></li>
                     <li>Fax: <a href="#"> 1-333-444-5555</a></li>
                     <li>WhatsApp: <a href="#"> 1-234-456-7895</a></li>
                     <li>Email:<a href="#">  john@realhomes.io</a></li>
                   </ul>
                 </div>
                 <a href="https://live.instaciti.com/{{dealerData.CityName}}/automative" target="_blank" class="viewMy" style="cursor: pointer;">  View My Listings </a>
                 <form class="pt-3 " >
                   <div class="mb-3 px-3">
                     <label for="exampleInputEmail1" class="form-label">Name</label>
                     <input type="name" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Name">
                   </div>
                   <div class="mb-3 px-3">
                     <label for="exampleInputPassword1" class="form-label">Email</label>
                     <input type="email" class="form-control" id="exampleInputPassword1" placeholder="Email">
                   </div>
                   <div class="mb-3 px-3">
                     <label for="exampleInputPassword1" class="form-label">phone</label>
                     <input type="phone" class="form-control" id="exampleInputPassword1" placeholder="phone">
                   </div>
                   <div class="mb-3 px-3">
                     <label for="exampleInputPassword1" class="form-label">phone</label>
                    <textarea class="form-control">Hello, I am interested in [Home in Merrick Way].  </textarea>
                   </div>
                   <div class="mb-3 px-3 form-check">
                
                     <input type="checkbox" class="form-check-input" id="exampleCheck1">
                     <label class="form-check-label" for="exampleCheck1">I consent to having this website store my submitted information so they can respond to my inquiry.</label>
                   </div>
                   <div class="btn-group" role="group" aria-label="Basic checkbox toggle button group">
                     <label class="btn btn-outline-primary" for="btncheck1"><i class="fa-brands fa-whatsapp"></i>WhatsApp </label>
                     <label class="btn btn-outline-primary" for="btncheck2"><i class="fa-solid fa-phone"></i>Call Now </label>
                 
                   </div>
                   <div class="btn-group mt-3" role="group" aria-label="Basic checkbox toggle button group">
                      <label class="btn message btn-outline-primary" for="btncheck2"><i class="fa-light fa-message"></i>Send Message </label>
                   
                   </div>
                 </form>
               </div>
               
               <div class="featuredBox">
                <h3 class="mb-4">Featured Properties</h3>
                <ng-container *ngFor="let list of dealerListingData;let i= index">
                  <div class="listingCard propertyCard" *ngIf="list.IsFeatured == 'Y'" >
                    <div class="imageWrapper featrue" (click)="navigate(list.ListingHandle)">
                      <span class="labelFeatured">Featured</span>
                        <a (click)="navigate(list.ListingHandle)">
                          <mdb-carousel class="carousel slide carousel-fade">
                            <mdb-carousel-item *ngFor="let item of getImages(list)">
                              <img *ngIf="item.MediaType == 'I' && item.MediaURL" [src]="item.MediaURL"
                                class="d-block w-100 rounded" alt="image" (error)="item.MediaURL = null" />
                              <video *ngIf="item.MediaType != 'I' && item.MediaURL" class="d-block w-100 rounded" controls
                                (error)="item.MediaURL = null">
                                >
                                <source [src]="item.MediaURL" type="video/mp4" (error)="item.MediaURL = null" />
                                Your browser does not support the video tag.
                              </video>
                              <h4 *ngIf="!item.MediaURL">
                                <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png" />
                              </h4>
                            </mdb-carousel-item>
                          </mdb-carousel>
                        </a>
                        
                        <div class="viewProperty" style="z-index: 10 !important;">
                          <a (click)="navigate2(list.ListingHandle)" style="cursor: pointer;">View Property</a>
                        </div>
                    </div>
                    <div class="bottomDetails border-0">
                        <div class="paddingSection">
                            <a>
                                <h5>{{list.Area}} Apartment</h5>
                            </a>
                            <div class="addedSty">
                                <p>{{list.Description}}</p> 
                            </div>
  
                            <ul>
                                <li>
                                    Bedrooms
                                    <div class="metaIcon mt-1">
                                      <i class="fa-solid fa-bed"></i>
                                      <span>{{list.Rooms}}</span>
                                    </div>
                                </li>
  
                                <li>
                                    Bathrooms
                                    <div class="metaIcon mt-1">
                                      <i class="fa-solid fa-shower"></i>
                                      <span>{{list.Bathrooms}}</span>
                                    </div>
                                </li>
                                <li>
                                    Area
                                    <div class="metaIcon mt-1">
                                      <i class="fa-sharp fa-regular fa-square"></i>
                                      <span>1650</span>
                                      <span>Sq Ft</span>
                                    </div>
                                </li>
                            </ul>
                            <div class="price-fav-box">
                              <div class="price-pabel">
                                  <span class="card-status"> For Sale    </span>
                                  <p class="card-price"> {{dealerData?.PrimaryCurrencyText}} {{list.AskingPrice}} Monthly  </p>
                              </div>
                              
                            </div>
                        </div>
                       
                    </div>
                  
                  </div>
                  </ng-container>
               </div>
            
            </div>
        </div>
    </div>
</section>

<footer>
  <div class="container">
      <div class="row">
          <div class="col-md-5">
              <img src="./img/autotrader.png" class="logo" alt="">
              <p class="mb-4">CarSpot Automotive Car Classified WordPress Theme is flexible and powerful Car Classified wordpress Theme for your all automotive & car listing business needs.</p>
              <ul class="social">
                  <li><a href="#"><i class="fa-brands fa-facebook-f"></i> </a></li>
                  <li><a href="#"><i class="fa-brands fa-twitter"></i> </a></li>
                  <li><a href="#"><i class="fa-brands fa-linkedin-in"></i> </a></li>
                  <li><a href="#"><i class="fa-brands fa-google-plus-g"></i></a></li>
                  <li><a href="#"><i class="fa-brands fa-youtube"></i> </a></li>
              </ul>
          </div>
          <div class="col-md-4">
              <h5>Quick Links</h5>

              <div class="d-flex">
                  <ul>
                      <li><a href="">Home</a></li>
                      <li><a href="">About Us</a></li>
                      <li><a href="">Comparison</a></li>
                      <li><a href="">Expert Reviews</a></li>
                  </ul>

                  <ul>
                      <li><a href="">Elements</a></li>
                      <li><a href="">Checkout</a></li>
                      <li><a href="">Packages</a></li>
                      <li><a href="">Contact Us</a></li>
                  </ul>
              </div>
           
          </div>
          <div class="col-md-3">
              <h5>Get Our Apps</h5>
              <a href="#" class="google">
                  <img src="./img/google.png" alt="">
              </a>
              <a href="#" class="apple">
                  <img src="./img/apple.png" alt="">
              </a>
          </div>

          <div class="col-12 text-center">
              <p class="copyright">© Copyright 2022  </p>
          </div>
      </div>
  </div>
</footer>